/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: app.ts
 * Class: app.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

// essentials
import Vue from 'vue';
import VueI18Next from '@panter/vue-i18next';
import { library } from '@fortawesome/fontawesome-svg-core';
import Axios from 'axios';
import i18next from 'i18next';
import { ConfigurationAPI } from './plugins/configuration/types/configuration';
import icons from './config/icons';
import BaseLayout from './view/app/BaseLayout.vue';
import { store } from './store';
import { router } from './router';

// --- animations (may no longer be required)
// --- @TODO: check if vue2-animate can be removed
import '../styles/vue/vue-toastification.scss';

import { useVueFeatures } from './appFeatures';

const features = useVueFeatures();
features.installDirectives();
features.installPlugins();
features.installGlobalComponents();

// Defensive guard against the browser back/forward cache (bfcache). A restored page keeps the
// DOM and in-memory configuration singleton from the previous load, which can leave the sidebar
// pointing at a stale region/locale prefix. Force a fresh load so all server-rendered state
// (region, locale, balance, customer) is re-read.
window.addEventListener('pageshow', (event: PageTransitionEvent): void => {
  if (event.persisted) {
    window.location.reload();
  }
});

require('vue2-animate/dist/vue2-animate.min.css');
require('@adyen/adyen-web/dist/adyen.css');

// --- importing icons we need (will be moved out of this file in the future
library.add(icons);

const graceTimeout = 1500;

// @TODO: do a research if we can use the Global API createApp here from the composition api
features
  .isI18NextReady({ graceTimeout })
  .then(() => {
    // eslint-disable-next-line no-new
    new Vue({
      el: '#vue-body-app',
      router,
      i18n: new VueI18Next(i18next),
      store,
      setup: () => {
        features.provideContainer();
      },
      computed: {
        config(): ConfigurationAPI {
          return this.$api;
        },
      },
      render: (h) => h(BaseLayout),
    });
  },
  (error) => {
    // --- happends only when i18next.on('initialized', loaded => false)
    throw error;
  });

Vue.prototype.$http = Axios;
